export default "__VITE_ASSET__CphaIClw__"